import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'models/meta/action';
import { navigate } from 'store/actions/common';
import { LoginSuccess } from './LoginSuccess.layout';
import { LoginSuccessProps, LoginSuccessDispatchProps } from './LoginSuccess.types';

const mapDispatchToProps = (dispatch: Dispatch): LoginSuccessDispatchProps =>
    ({ dispatchNavigate: (location, options) => { dispatch(navigate(location, options)); } });

export default compose<React.FC<Partial<LoginSuccessProps>>>(
    withTranslation('common'),
    connect(null, mapDispatchToProps)
)(LoginSuccess);
